import React from 'react';

export interface StockTagItem {
  tag_id: number;
  code: string;
  name: string;
  category: string;
}

interface AShareStockTagsBadgeProps {
  tags?: StockTagItem[];
  emptyPlaceholder?: string;
  maxDisplay?: number;
}

export const AShareStockTagsBadge: React.FC<AShareStockTagsBadgeProps> = ({
  tags = [],
  emptyPlaceholder = '--',
  maxDisplay,
}) => {
  if (!tags || tags.length === 0) {
    return <span style={{ color: 'var(--text-muted)', fontSize: '11px' }}>{emptyPlaceholder}</span>;
  }

  const displayTags = maxDisplay ? tags.slice(0, maxDisplay) : tags;
  const overflowCount = maxDisplay && tags.length > maxDisplay ? tags.length - maxDisplay : 0;

  const getCategoryClass = (category: string, code: string): string => {
    switch (category) {
      case 'VOLUME':
        return code === 'VOL_DRYUP' ? 'tag-cyan' : 'tag-warning';
      case 'MA':
        if (code === 'MA_BULL') return 'tag-emerald';
        if (code === 'MA_BEAR') return 'tag-rose';
        return 'tag-purple';
      case 'VOLATILITY':
        return 'tag-cyan';
      case 'MOMENTUM':
        return 'tag-rose';
      default:
        return 'tag-neutral';
    }
  };

  return (
    <div
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: '4px',
        alignItems: 'center',
      }}
      data-testid="ashare-stock-tags-group"
    >
      {displayTags.map((tag) => {
        const tagClass = getCategoryClass(tag.category, tag.code);
        return (
          <span
            key={tag.code}
            data-testid={`stock-tag-${tag.code.toLowerCase()}`}
            title={`分类: ${tag.category} | 代码: ${tag.code}`}
            className={`stock-tag-item ${tagClass}`}
          >
            {tag.name}
          </span>
        );
      })}
      {overflowCount > 0 && (
        <span
          title={`还有 ${overflowCount} 个其他形态标签`}
          style={{
            fontSize: '9px',
            padding: '1px 4px',
            borderRadius: '2px',
            background: 'var(--bg-base)',
            color: 'var(--text-muted)',
            fontFamily: 'var(--font-mono)',
          }}
        >
          +{overflowCount}
        </span>
      )}
    </div>
  );
};
